module.exports = __webpack_public_path__ + "static/media/elegant-pendent_720x480.d5ef465a.jpg";